module.exports = __webpack_public_path__ + "static/media/bg.b2945878.jpg";